export const CANONICAL_TOP_LEVEL_KEYS = [
    'remedy',
    'kind',
    'intent',
    'owners',
    'tags',
    'entities',
    'files',
    'features',
    'flows',
    'integrations',
    'permissions',
    'ui',
    'design',
    'marketplace',
    'runtime',
    'parent',
    'version',
];
export const CANONICAL_IDENTITY_KEYS = ['id', 'name', 'domain'];
export const CANONICAL_FILE_ENTRY_KEYS = ['ext', 'path', 'pattern', 'required'];
export const CANONICAL_FEATURE_KEYS = [
    'id',
    'intent',
    'triggers',
    'preconditions',
    'steps',
    'outputs',
    'errors',
    'tags',
    'version',
];
export const CANONICAL_FLOW_KEYS = ['id', 'intent', 'steps', 'outputs', 'version'];
export const RESERVED_ROLES = new Set([
    'spec',
    'design',
    'schema',
    'fixtures',
    'code',
    'tests',
    'docs',
    'prompt',
    'embedding-source',
]);
//# sourceMappingURL=types.js.map